export default __webpack_public_path__ + "media/images/paylogos/gray/electron@2x-43d45d5bb01a4a2c18a8024665894871.png";